import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import "../PRmanagerLayout/PRmanager.css";
import "./SubAccount.css";
import { useEffect, useState } from "react";
import Instance from "../../Utils/Axios";
import { Link, useNavigate } from "react-router-dom";
import { showToast } from "../../Utils/index";
import useFormValidation from "../../Hooks/useformValidation";
import { SubAccountSchema } from "../../Utils/validationSchema";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import { Controller } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const AddSubLayout = () => {
  const [successMessage, setSuccessMessage] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useFormValidation(SubAccountSchema, {});

  const watchCountry = watch("country");

  const onSubmit = (data) => {
    const token = localStorage.getItem("tokenId");
    Instance.post("/user/usercompany/create", {
      ...data,
      // tokenId: token,
    })
      .then((response) => {
        if (response.data.resCode === "200") {
          setSuccessMessage(response.data.resMessage);
          // setError("");
          showToast("Company Created Successfully!", "success", "success");
          setTimeout(() => {
            navigate("/customer/sub-account");
          }, 2000);
        } else {
          showToast("Failed to create company", "error", "error");
          console.error("Error:", response.data.resMessage);
        }
      })
      .catch((error) => {
        showToast("Failed to create company", "error", "error");
        console.error("Error:", error);
      });
  };

  const handleCancel = () => {
    reset({});
    // setError("");
    setSuccessMessage("");
    setShowModal(false);
  };

  const fetchCountryList = () => {
    const token = localStorage.getItem("tokenId");
    Instance.post("/user/common/countryList", {
      // tokenId: token,
      status: "ACTIVE",
    })
      .then((response) => {
        if (response.data.resCode === "200") {
          const filteredCountries = response.data.message.filter(
            (country) => country.countryName.trim() !== ""
          );
          const sortedCountries = filteredCountries.sort((a, b) =>
            a.countryName.localeCompare(b.countryName)
          );
          setCountryList(sortedCountries);
          // setError("");
        } else {
          showToast("Failed to fetch countries list", "error", "error");
          console.error(
            "Error fetching countries list:",
            response.data.resMessage
          );
        }
      })
      .catch((error) => {
        showToast("Failed to fetch countries list", "error", "error");
        console.error("Error fetching countries list:", error);
      });
  };

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    fetchCountryList();
  }, []);

  useEffect(() => {
    if (countryList.length > 0) {
      const india = countryList.find(
        (c) => c.countryCode === "IN"
      );

      if (india) {
        setValue("isdCode", india.isdCode);
        setValue("country", india.countryCode);
      }
    }
  }, [countryList]);

  return (
    <div className="sub_account_add_wrapper">
      <div className={`pr_secondary_nav`}>
        <Link to="/customer/sub-account">
          <button className="sub_back_btn mt-3">
            <img
              className={"sub_back_img"}
              src="/build/img/Icons/Chevron.svg"
              alt="Back"
              width={20}
              height={20}
            />
            Back
          </button>
        </Link>
      </div>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className="pr_form_preview">
          <h4 className="sub_form_head mb-4">Add a new company profile</h4>

          <Row>
            <Col className="custom_col_sub_account mb-4">
              <Form.Label>Company Name</Form.Label>
              <Form.Control
                placeholder="Enter Company Name"
                {...register("name")}
              />
              {errors.name && <p className="text-danger">{errors.name.message}</p>}
            </Col>

            <Col className="custom_col_sub_account mb-4">
              <Form.Label>Contact Person Name</Form.Label>
              <Form.Control
                placeholder="Enter Contact Person Name"
                {...register("contactPerson")}
              />
              {errors.contactPerson && <p className="text-danger">{errors.contactPerson.message}</p>}
            </Col>
          </Row>

          <Row>
            <Col className="custom_col_sub_account mb-4">
              <Form.Label>Company Website</Form.Label>
              <Form.Control
                placeholder="Enter Website"
                {...register("website")}
              />
              {errors.website && <p className="text-danger">{errors.website.message}</p>}
            </Col>

            {/* <Col className="custom_col_sub_account mb-4">
              <Form.Label>Created By</Form.Label>
              <Form.Control
                placeholder="Enter Created By"
                {...register("createdBy")}
              />
              {errors.createdBy && <p className="text-danger">{errors.createdBy.message}</p>}
            </Col> */}
          </Row>

          <Row>
            <Col className="custom_col_sub_account mb-4">
              <Form.Label>Company Address</Form.Label>
              <Form.Control
                placeholder="Enter Address"
                {...register("address")}
              />
              {errors.address && <p className="text-danger">{errors.address.message}</p>}
            </Col>
          </Row>

          <Row>
            <Col xs="6" className="custom_col_sub_account mb-4">
              <Form.Label>Country</Form.Label>
              <Controller
                name="country"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={countryList.map((country) => ({
                      value: country.countryCode,
                      label: country.countryName,
                      isdCode: country.isdCode
                    }))}
                    formatOptionLabel={({ label, value }) => (
                      <div className="d-flex align-items-center">
                        <img
                          src={`https://flagcdn.com/w20/${value.toLowerCase()}.png`}
                          alt=""
                          className="me-2"
                          style={{ width: "20px", height: "auto" }}
                        />
                        <span>{label} ({value})</span>
                      </div>
                    )}
                    placeholder="Select Country"
                    isSearchable
                    menuPlacement="auto"
                    menuPosition="fixed"
                    minMenuHeight={300}
                    classNamePrefix="react-select"
                    value={
                      field.value
                        ? {
                          value: field.value,
                          label: countryList.find(c => c.countryCode === field.value)?.countryName || field.value,
                        }
                        : null
                    }
                    onChange={(val) => {
                      field.onChange(val.value);
                    }}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        borderRadius: "8px",
                        borderColor: state.isFocused ? "#585edb" : "#ced4da",
                        boxShadow: "none",
                        "&:hover": {
                          borderColor: "#585edb",
                        },
                        minHeight: "45px",
                      }),
                      menu: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                      menuList: (base) => ({
                        ...base,
                        maxHeight: "200px",
                      }),
                      option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isSelected
                          ? "#585edb"
                          : state.isFocused
                            ? "#f1f2fd"
                            : "transparent",
                        color: state.isSelected ? "white" : "#091e42",
                        "&:active": {
                          backgroundColor: "#585edb",
                        },
                      }),
                    }}
                  />
                )}
              />
              {errors.country && <p className="text-danger">{errors.country.message}</p>}
            </Col>

            <Col xs="3" className="custom_col_sub_account mb-4">
              <Form.Label>City</Form.Label>
              <Form.Control
                placeholder="Enter City"
                {...register("city")}
              />
              {errors.city && <p className="text-danger">{errors.city.message}</p>}
            </Col>

            <Col xs="3" className="custom_col_sub_account mb-4">
              <Form.Label>State</Form.Label>
              <Form.Control
                placeholder="Enter State"
                {...register("state")}
              />
              {errors.state && <p className="text-danger">{errors.state.message}</p>}
            </Col>

          </Row>

          <Row>
            <Col className="custom_col_sub_account mb-4">
              <Form.Label>Email</Form.Label>
              <Form.Control
                placeholder="Enter Email"
                type="email"
                {...register("email")}
              />
              {errors.email && <p className="text-danger">{errors.email.message}</p>}
            </Col>

            <Col className="custom_col_sub_account mb-4">
              <Form.Label>Phone Number</Form.Label>
              <div className="phone_input_wrapper">
                <div className="isd_code_dropdown">
                  <Controller
                    name="isdCode"
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={countryList.map((country) => ({
                          value: country.isdCode,
                          label: country.isdCode,
                          countryCode: country.countryCode,
                          countryName: country.countryName,
                        }))}
                        filterOption={(option, inputValue) => {
                          const data = option.data;
                          const searchStr = inputValue.toLowerCase();
                          return (
                            data.label.toLowerCase().includes(searchStr) ||
                            data.countryName.toLowerCase().includes(searchStr) ||
                            data.countryCode.toLowerCase().includes(searchStr)
                          );
                        }}
                        formatOptionLabel={({ label, countryCode, countryName }, { context }) => (
                          <div className="d-flex align-items-center justify-content-between w-100">
                            <div className="d-flex align-items-center">
                              <img
                                src={`https://flagcdn.com/w20/${countryCode.toLowerCase()}.png`}
                                alt=""
                                className="me-2"
                                style={{ width: "15px", height: "auto" }}
                              />
                              <span>{label}</span>
                            </div>
                          </div>
                        )}
                        placeholder="+91"
                        isSearchable
                        menuPlacement="auto"
                        menuPosition="fixed"
                        minMenuHeight={300}
                        classNamePrefix="react-isd-select"
                        menuPortalTarget={document.body}
                        value={
                          field.value
                            ? (() => {
                              const cleanField = String(field.value).replace("+", "");
                              const selectedCountry = countryList.find(
                                (c) => String(c.isdCode || "").replace("+", "") === cleanField
                              );
                              return selectedCountry
                                ? {
                                  value: selectedCountry.isdCode,
                                  label: selectedCountry.isdCode,
                                  countryCode: selectedCountry.countryCode,
                                }
                                : null;
                            })()
                            : null
                        }
                        onChange={(val) => {
                          field.onChange(val.value);

                          const cleanVal = String(val.value).replace("+", "");
                          const selectedCountry = countryList.find(
                            (c) => String(c.isdCode || "").replace("+", "") === cleanVal
                          );

                          if (selectedCountry) {
                            setValue("isdCode", selectedCountry.isdCode);
                          }

                          setValue("mobile", "");
                        }}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            borderRadius: "8px 0 0 8px",
                            borderColor: "transparent",
                            boxShadow: "none",
                            "&:hover": {
                              borderColor: "transparent",
                            },
                            minHeight: "48px",
                            borderRight: "none",
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 9999,
                            width: "150px",
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                          menuList: (base) => ({
                            ...base,
                            maxHeight: "180px",
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? "#585edb"
                              : state.isFocused
                                ? "#f1f2fd"
                                : "transparent",
                            color: state.isSelected ? "white" : "#091e42",
                            "&:active": {
                              backgroundColor: "#585edb",
                            },
                          }),
                        }}
                      />
                    )}
                  />
                </div>
                <div className="phone_number_input">
                  <Form.Control
                    placeholder="Enter Phone Number"
                    type="text"
                    {...register("mobile")}
                  />
                </div>
              </div>
              {(errors.mobile || errors.isdCode) && (
                <p className="text-danger">
                  {errors.isdCode?.message || errors.mobile?.message}
                </p>
              )}
            </Col>
          </Row>


          {/* {successMessage && <p className="text-success">{successMessage}</p>} */}
        </div>

        <div className="sub_account_buttons">
          <button
            className="sub_cancel_btn mb-4"
            onClick={handleShowModal}
            type="button"
          >
            Cancel
          </button>
          <button className="sub_save_btn mb-4" type="submit">
            Save Changes
          </button>
        </div>
      </Form>
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        className="cancel_modal"
      >
        <Modal.Body>
          {/* <div className="submit_modal_img">
                              <img
                                className={"submit_done_img"}
                                src="/build/Done.svg"
                                alt="zex pr wire Logo"
                                width={140}
                                height={140}

                              />
                            </div> */}
          <div>
            <h5 className="submit_modal_head">Cancel</h5>
            <p className="submit_modal_content">
              Are you sure you want to cancel? Any unsaved changes will be lost.
            </p>
          </div>
          <div className="pr_modal_btn">
            <Button
              className="submit_cancel_btn"
              onClick={handleCloseModal}
            >
              No
            </Button>
            <Button
              className="submit_save_btn"
              onClick={handleCancel}
            >
              Yes
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddSubLayout;
